export const COUNTRY_STATE_DEFINITIONS = "/CountryStateDef/GetCountryStateDefinitions"
export const COUNTRY_STATE_INSERT = "/CountryStateDef/InsertCountryStateDefinition"
export const COUNTRY_STATE_UPDATE = "/CountryStateDef/UpdateCountryStateDefinition"
export const COUNTRY_STATE_DELETE = "/CountryStateDef/DeleteCountryStateDefinition"